var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { useField } from 'react-final-form';
import { useFieldArray } from 'react-final-form-arrays';
import createPreviewData from './createPreviewData';
import createHeaderFooterString from './createHeaderFooterString';
import RenderInvisibles from './RenderInvisibles';
export default function ExportPreviewData() {
    var _this = this;
    var isAggregate = useField('aggregate', {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : false; },
    }).input.value;
    var header = useFieldArray('header', {
        subscription: { value: true },
    }).fields.value;
    var data = useFieldArray('data', {
        subscription: { value: true },
    }).fields.value;
    var dataAggregate = useFieldArray('dataAggregate', {
        subscription: { value: true },
    }).fields.value;
    var footer = useFieldArray('footer', {
        subscription: { value: true },
    }).fields.value;
    var showInvisible = useField('preview.invisible', {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : false; },
    }).input.value;
    var _a = useState(''), contents = _a[0], setContents = _a[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var dataToUse, _a, dataPreview, totalAmount, totalCount, headerPreview, footerPreview;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        dataToUse = (_b = (isAggregate ? dataAggregate : data)) !== null && _b !== void 0 ? _b : [];
                        return [4 /*yield*/, createPreviewData(dataToUse, isAggregate)];
                    case 1:
                        _a = _c.sent(), dataPreview = _a.dataPreview, totalAmount = _a.totalAmount, totalCount = _a.totalCount;
                        headerPreview = createHeaderFooterString(header !== null && header !== void 0 ? header : [], totalAmount, totalCount);
                        footerPreview = createHeaderFooterString(footer !== null && footer !== void 0 ? footer : [], totalAmount, totalCount);
                        // Concatenate header, data, and footer then update state
                        setContents(headerPreview + dataPreview + footerPreview);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [header, data, dataAggregate, footer, isAggregate]);
    return React.createElement(RenderInvisibles, { text: contents, showInvisible: showInvisible });
}
